import styled from 'styled-components';
import { rem } from 'polished';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const StyledInfo = styled.div`
  background-color: ${colors.primary};
  padding: 1rem 0;

  & > div > div {
    height: 100%;
    margin-bottom: 0;
    align-items: center;

    & > div {


      &:not(:first-child) {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  p {
    color: ${colors.background};
    margin: 0 !important;

    &:first-child {
      font-weight: 500;
      margin-bottom: 0.5em;
    }
  }

  a, a:hover {
    color: ${colors.W};
    text-decoration: underline;
    font-size: 16px;
  }

  button {
    &,
    &:hover {
      color: ${colors.W};
      span {
        text-decoration: underline;
        font-size: 16px;
      }
    }
  }


  ${media.tabletSmall`
    font-size: ${rem(14)};
  `};

  @media print {
    display: none !important;
  }
`;



// WEBPACK FOOTER //
// ./src/modules/CookieInfo/styled.js